import { Button, Container, Header } from "@amzn/awsui-components-console";
import React from "react";

import ChatMessages from "@/components/chat/ChatMessages";
import { getGenAiMessage,getHumanMessage } from "@/components/chat/utils";
import useReadOnlyChatModal from "@/hooks/admin/useReadOnlyChatModal";
import { UserFromApi } from "@/types/user";

import { MessageItem } from "../types";

export interface ConversationContextSectionProps {
  message: MessageItem;
  sender: UserFromApi;
}

const ConversationContextSection: React.FC<ConversationContextSectionProps> = ({
  message,
  sender,
}) => {
  const { toggle: toggleChatModal, ModalComponent: ReadOnlyChatModal } =
    useReadOnlyChatModal({
      user: sender,
    });

  return (
    <Container
      header={
        <Header
          actions={
            <Button onClick={() => toggleChatModal(message.conversationId)}>
              View Full Conversation
            </Button>
          }
        >
          Conversation Context
        </Header>
      }
    >
      <ChatMessages
        messages={[
          getHumanMessage(sender, {
            content: message.userMessage,
            timestamp: message.created,
          }),
          getGenAiMessage({
            content: message.botResponse,
            timestamp: message.created,
          }),
        ]}
      />
      {ReadOnlyChatModal()}
    </Container>
  );
};

export default ConversationContextSection;
